<div style="height: 10px; width: 100%; background-color: #f8f9fa"></div>
<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav mode="side" [opened]="isExpanded">
        <mat-nav-list>
            <div>
                <mat-list-item (click)="toggleLoginSubmenu($event)">
                    <div class="menu-item">
                        <a href="#">Security</a>
                        <fa-icon
                            [icon]="
                                securitySubMenu ? faChevronUp : faChevronDown
                            "
                            style="display: block; height: 16px; width: 16px"
                        ></fa-icon>
                    </div>
                </mat-list-item>
                <mat-nav-list *ngIf="securitySubMenu" style="margin-left: 10px">
                    <a
                        mat-list-item
                        href="#/"
                        [class.selected]="
                            selectedReport === 'failedLoginAttempts'
                        "
                        (click)="onChangeReport($event, 'failedLoginAttempts')"
                        >Failed Login Attempts</a
                    >
                    <a
                        mat-list-item
                        href="#/"
                        [class.selected]="selectedReport === 'mfaConfiguration'"
                        (click)="onChangeReport($event, 'mfaConfiguration')"
                        >MFA Configuration</a
                    >
                </mat-nav-list>
            </div>
            <div>
                <mat-list-item (click)="toggleCheckinSubmenu($event)">
                    <div class="menu-item">
                        <a href="#/">User Accounts</a>
                        <fa-icon
                            [icon]="
                                userAccountSubMenu ? faChevronUp : faChevronDown
                            "
                            style="display: block; height: 16px; width: 16px"
                        ></fa-icon>
                    </div>
                </mat-list-item>
                <mat-nav-list
                    *ngIf="userAccountSubMenu"
                    style="margin-left: 10px"
                >
                    <a
                        mat-list-item
                        [class.selected]="
                            selectedReport === 'userCheckInAttempts'
                        "
                        href="#/"
                        (click)="onChangeReport($event, 'userCheckInAttempts')"
                        >User Checkin Attempts</a
                    >
                    <a
                        mat-list-item
                        [class.selected]="
                            selectedReport === 'userCheckoutAttempts'
                        "
                        href="#/"
                        (click)="onChangeReport($event, 'userCheckoutAttempts')"
                        >User Checkout Attempts</a
                    >
                </mat-nav-list>
            </div>
            <div>
                <mat-list-item (click)="toggleDevicesSubmenu($event)">
                    <div class="menu-item">
                        <a href="#/">Devices</a>
                        <fa-icon
                            [icon]="
                                devicesSubMenu ? faChevronUp : faChevronDown
                            "
                            style="display: block; height: 16px; width: 16px"
                        ></fa-icon>
                    </div>
                </mat-list-item>
                <mat-nav-list *ngIf="devicesSubMenu" style="margin-left: 10px">
                    <a
                        mat-list-item
                        [class.selected]="selectedReport === 'sessionCapture'"
                        href="#/"
                        (click)="onChangeReport($event, 'sessionCapture')"
                        >Session Capture</a
                    >
                    <!-- <a mat-list-item [class.selected]="selectedReport === 'deviceHistory'" href="#/"
                        (click)="onChangeReport($event,'deviceHistory')">Device History</a> -->
                </mat-nav-list>
            </div>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content style="overflow-x: hidden">
        <div class="row align-items-start">
            <div class="col-auto">
                <button
                    type="button"
                    mat-icon-button
                    (click)="isExpanded = !isExpanded"
                >
                    <fa-icon [icon]="isExpanded ? faTimes : faBars"></fa-icon>
                    <!-- <mat-icon>{{ isExpanded ? 'menu_open' : 'menu' }}</mat-icon> -->
                </button>
            </div>
            <div class="" style="margin-left: 10px; margin-top: 10px">
                <h2>{{ this.reportName(this.selectedReport) }}</h2>
            </div>
        </div>

        <br />
        <div class="row align-items-start" style="margin-left: 20px">
            <div class="col-md-auto">
                <mat-form-field>
                    <mat-label>Search</mat-label>
                    <input
                        matInput
                        type="text"
                        placeholder="Search..."
                        [(ngModel)]="quickFilterText"
                        (input)="onFilterTextBoxChanged($event)"
                    />
                </mat-form-field>
            </div>
            <div class="col-md-auto">
                <mat-form-field>
                    <mat-label>Select Company</mat-label>
                    <mat-select
                        [value]="selectedOrganizationId"
                        (selectionChange)="onOrganizationChange($event)"
                    >
                        <mat-option
                            *ngFor="let org of organizations"
                            [value]="org.CompanyId"
                            >{{ org.Name }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="col-md-auto"
                *ngIf="
                    this.selectedReport === 'failedLoginAttempts' ||
                    'userCheckInAttempts' ||
                    'userCheckoutAttempts'
                "
            >
                <mat-form-field>
                    <mat-label>Select Account</mat-label>
                    <mat-select
                        [value]="selectedUserId"
                        (selectionChange)="onUserChange($event)"
                    >
                        <mat-option
                            *ngFor="let user of users"
                            [value]="user.UserId"
                            >{{ user.UserName }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="col-md-auto"
                *ngIf="this.selectedReport == 'sessionCapture'"
            >
                <mat-form-field>
                    <mat-label>Select External Camera</mat-label>
                    <mat-select
                        [value]="selectedCamera"
                        (selectionChange)="onExternalCameraChange($event)"
                    >
                        <mat-option
                            *ngFor="let camera of externalCameras"
                            [value]="camera.Key"
                            >{{ camera.Value }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="col-md-auto"
                *ngIf="this.selectedReport == 'deviceHistory'"
            >
                <mat-form-field>
                    <mat-label>Select Device Sr No.</mat-label>
                    <mat-select
                        [value]="selectedSerialNumber"
                        (selectionChange)="onDeviceSerialNumberChange($event)"
                    >
                        <mat-option
                            *ngFor="let srNo of deviceSerialNumbers"
                            [value]="srNo.Key"
                            >{{ srNo.Value }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="col-md-auto"
                *ngIf="this.selectedReport != 'mfaConfiguration'"
            >
                <mat-form-field>
                    <mat-label>Date range</mat-label>
                    <mat-date-range-input
                        [formGroup]="range"
                        [rangePicker]="picker"
                    >
                        <input
                            matStartDate
                            (dateChange)="onDateToChange($event)"
                            formControlName="start"
                            placeholder="Start date"
                        />
                        <input
                            matEndDate
                            (dateChange)="onDateToChange($event)"
                            formControlName="end"
                            placeholder="End date"
                        />
                    </mat-date-range-input>
                    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                    <mat-datepicker-toggle
                        matIconSuffix
                        [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-error
                        *ngIf="
                            range.controls.start.hasError('matStartDateInvalid')
                        "
                        >Invalid start date</mat-error
                    >
                    <mat-error
                        *ngIf="range.controls.end.hasError('matEndDateInvalid')"
                        >Invalid end date</mat-error
                    >
                </mat-form-field>
            </div>
            <div class="row" style="margin-bottom: 10px; width: 99%">
                <div
                    *ngIf="this.isExportable"
                    class="col-md-12"
                    style="
                        display: flex;
                        align-items: flex-end;
                        justify-content: flex-end;
                    "
                >
                    <button
                        type="button"
                        class="btn btn-success"
                        style="margin-top: 10px"
                        (click)="onBtnExport()"
                    >
                        Export
                    </button>
                </div>
            </div>
        </div>
        <section
            class="content"
            style="display: block; background-color: #f8f9fa"
        >
            <div class="container-fluid">
                <div class="row" style="margin-bottom: 24px">
                    <div class="col-12">
                        <div class="grid-pagination-container">
                            <ag-grid-angular
                                *ngIf="rowData && colDefs"
                                style="width: 100%; flex-grow: 1"
                                [class]="themeClass"
                                [rowData]="rowData"
                                [columnDefs]="colDefs"
                                [pagination]="true"
                                [paginationPageSize]="20"
                                [paginationPageSizeSelector]="[
                                    20, 50, 100, 200, 1000
                                ]"
                                (gridReady)="onGridReady($event)"
                                [suppressMovableColumns]="true"
                            >
                            </ag-grid-angular>
                            <!-- <app-pagination style="z-index:1" [currentPage]="getCurrentPage()" [totalPages]="getTotalPages()"
                                (changePage)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
                            </app-pagination> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </mat-sidenav-content>
</mat-sidenav-container>
